import clsx from 'clsx';
import { forwardRef } from 'react';

export const Container = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { fullScreen?: boolean }
>(({ className, fullScreen, ...props }, ref) => (
  <div
    ref={ref}
    className={clsx(
      'tw-block tw-mx-auto tw-w-full tw-px-2 sm:tw-px-2.4 md:tw-px-3.2',
      fullScreen
        ? 'tw-max-w-[1152px] lg:tw-px-0'
        : 'tw-max-w-[1462px] lg:tw-px-4.8',
      className,
    )}
    {...props}
  />
));

Container.displayName = 'Container';
